import { render } from "./DocumentGenerator.vue?vue&type=template&id=e56625e2&ts=true"
import script from "./DocumentGenerator.vue?vue&type=script&lang=ts"
export * from "./DocumentGenerator.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\cst\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__